import React from 'react';
import * as imageUtil from '@umu/umu-image-handle';

import './index.scss';

interface IProps {
    imgSrc: string;
    className: string;
    styleOption?: React.CSSProperties;
    onClick?: () => void;
}

export const Icon = (props: IProps) => {
    return (
        <div className={props.className} onClick={props.onClick}>
            <img src={imageUtil.appendWidth(props.imgSrc)} style={props.styleOption} className="micro-icon-img" />
        </div>
    );
};

export const IconClose = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.18744 4.18756C3.83961 4.53539 3.83961 5.09934 4.18744 5.44717L11.1153 12.375L4.18744 19.3028C3.8396 19.6507 3.83961 20.2146 4.18744 20.5624C4.53526 20.9103 5.09921 20.9103 5.44704 20.5624L12.3749 13.6346L19.3027 20.5624C19.6505 20.9103 20.2145 20.9103 20.5623 20.5624C20.9101 20.2146 20.9101 19.6507 20.5623 19.3028L13.6345 12.375L20.5623 5.44717C20.9101 5.09934 20.9101 4.53539 20.5623 4.18756C20.2145 3.83973 19.6505 3.83973 19.3027 4.18757L12.3749 11.1154L5.44704 4.18756C5.09921 3.83973 4.53526 3.83974 4.18744 4.18756Z"
                fill="currentColor"
            />
        </svg>
    );
};
